PublicPage = window.PublicPage || {};

PublicPage.init = function () {
    $('.menu__item').addClass("animateFast");
    $('.menu__children').addClass("animateFast");
    $('a').addClass("animateFast");
    $('.a2').addClass("animateFast");
    $('.btn').addClass("animateFast");

    /*var $header = $('.header');//.addClass("animateFast");
    //$header.addClass("animateFast");
    var limit=200;//$(".section1").height();
    var onScrollResize=function() {
        if ( $header.hasClass("header--trans") ) return;

        var scrollTop = $(window).scrollTop();
        //console.log(scrollTop+":"+$(".section1").height());

        if ( scrollTop>limit && !$header.hasClass("header--scrolled") ) {
            $header.addClass("header--trans");
            $header.fadeOut(300,function(){
                $header.addClass("header--scrolled");
                $header.fadeIn(300,function() {
                    $header.removeClass("header--trans");
                });
            });
        }
        else if (scrollTop<=limit && $header.hasClass("header--scrolled") ) {
            $header.addClass("header--trans");
            $header.fadeOut(300,function(){
                $header.removeClass("header--scrolled");
                $header.fadeIn(300,function(){
                    $header.removeClass("header--trans");
                });
            });
        }

        if($(window).width()>HomePage.WIDTH_ADOPT3) $(".section3-logo-block").css({left:$(".header-logo").position().left,right:"auto"});
        else $(".section3-logo-block").css({left:0,right:0});

        // ресайз секций:
        var h = $(window).height();
        $(".section1").css({height:h});
        $(".section3").css({height:h});
    };
    onScrollResize();
    $(window).on("scroll resize", onScrollResize);
*/
    $("ul#doex a").on("click", function(e){
        e.preventDefault();

        var $el = $(this),
            s = $el.attr("href"),
            go = $el.attr('data-go');

        $("ul#doex li").each(function(){
            $(this).removeClass("active");
        });

        $(this).parent().addClass("active");

        $(".rasplo1").each(function(){
            $(this).removeClass("active");
        });

        $("#doex1cont").each(function(){
            $(this).find('.doctroer').removeClass("active");
        });

        $('#go_' + go).addClass('active');
        $(s).addClass("active");

        return false;
    });

    $("ul#doex1 a").on("click", function(){
        var s = $(this).attr("href");
        $("ul#doex1 li").each(function(){
            $(this).removeClass("active");
        });
        $(this).parent().addClass("active");
        $("#doex1cont>div").each(function(){
            $(this).removeClass("active");
        });
        $(s).addClass("active");

        return false;
    });

    $(".tab").on("click", function () {
        var index = $(this).index();
        var activeIndex = $(this).closest("ul").find(".tab--sel").index();
        if (index == activeIndex) return;
        //console.log("Index: "+index);
        //console.log("Selected index: "+activeIndex);

        var $contents = $(this).closest("ul").next("ul.tab-content-list").find("li.tab-content");
        //console.log("Contents: "+$contents.length);
        var $contentNew = $contents.eq(index);
        var $contentPrev = $contents.eq(activeIndex);
        var $prev = $(this).closest("ul").find(".tab--sel");

        $contentPrev.addClass("tab-content--hidden");
        $contentNew.removeClass("tab-content--hidden");
        $prev.removeClass("tab--sel");
        $(this).addClass("tab--sel");
    });


    if(!$.cookie('welcomeScreen')) {
        $.cookie('welcomeScreen', 'true');


        setTimeout(function() {
            $('#welcomeScreen').remodal().open();
        }, 2000);
    }


    $('.fancybox').fancybox({
        openEffect	: 'none',
        closeEffect	: 'none',
        closeBtn		: true,
        padding : 6,
        helpers		:
            {
                title: { type : 'inside' },
                overlay: { locked: false }
            }
    });
};

$(PublicPage.init);

window.PublicPage = PublicPage;


// WEBPACK FOOTER //
// ../htdocs/js/PublicPage.js